<template>
  <div class="system-menu">
    <ul>
      <li class="system-menu-title">Hesap Yönetimi</li>

      <li
        v-for="(table, index) in $root.cache.tables"
        v-if="table.location == 2"
      >
        <template v-if="table.url">
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: table.url, params: { index } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
        <template v-else>
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: 'adminDetail', params: { index, table: table.table } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
      </li>
      <li class="system-menu-title">Satış süreci özelleştirme</li>
      <li
        v-for="(table, index) in $root.cache.tables"
        v-if="table.location == 3"
      >
        <template v-if="table.url">
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: table.url, params: { index } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
        <template v-else>
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: 'adminDetail', params: { index, table: table.table } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
      </li>
      <li class="system-menu-title">Raporlar</li>

      <li
        v-for="(table, index) in $root.cache.tables"
        v-if="table.location == 4"
      >
        <template v-if="table.url">
          <router-link
            class="url-flex"
            :class="{
              'active-url font-medium': $route.params.index == index
            }"
            :to="{ name: table.url, params: { index } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
        <template v-else>
          <router-link
            class="url-flex"
            :to="{ name: 'adminDetail', params: { index, table: table.table } }"
          >
            <vk-icon ratio="1" class="opacity-40" :icon="table.icon"></vk-icon>
            <span>{{ table.name }}</span>
          </router-link>
        </template>
      </li>
      <li>
        <a href="#" @click="resetCache()">Reset Cache</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    resetCache() {
      localStorage.removeItem("getOptionList");
    }
  }
};
</script>

<style>
.system-menu ul {
  margin: 0px;
  padding: 0px;
  padding: 10px;
}

.system-menu h3 {
  font-size: 20px;
  padding: 10px;
  margin: 0px;
}

.system-menu ul li {
  display: block;
  padding: 5px;
  border-radius: 5px;
}

.system-menu a {
  @apply text-gray-600;
}

.system-menu ul li:hover a {
  color: #222;
  text-decoration: none;
}

.system-menu ul li:hover {
  @apply bg-pampas;
}

.system-menu-title {
  color: #000;
  margin: 10px 5px;
}

.system-menu-title:hover {
  background: transparent !important;
}
</style>
